import { AddressElement, PaymentElement, useElements } from '@stripe/react-stripe-js';
import { useMountEffect } from '@tock/hooks';
import { useSetupIntent } from './useSetupIntent';

type CallSite = 'consumer_profile' | 'consumer_checkout';

interface Props {
  darkMode?: boolean;
  callSite?: CallSite;
  showAddressFields?:boolean;
  paymentElementOnReady?: ()=>any;
}

export const NewCardPaymentElement = ({ darkMode = false, callSite, showAddressFields= false, paymentElementOnReady = undefined}: Props) => {
  const elements = useElements();
  const { clientSecret, refreshSetupIntent } = useSetupIntent();
  useMountEffect(() => {
    refreshSetupIntent();
    if (elements) {
      elements.update({
        appearance: {
          theme: darkMode ? 'night' : 'stripe',
          // This is where we can put some styling variables
          // See: https://docs.stripe.com/elements/appearance-api?platform=web#variables
          variables: {
            fontFamily: "'Oracle', 'Helvetica', 'sans-serif'",
            fontSizeBase: '16px',
            fontSize3Xs: callSite == 'consumer_checkout' ? '15px' : '12px',
            fontSize2Xs: callSite == 'consumer_checkout' ? '15px' : '12px',
            fontSizeXs: callSite == 'consumer_checkout' ? '15px' : '12px',
            fontSizeSm: callSite == 'consumer_checkout' ? '15px' : '12px',
            fontSizeLg: '16px',
            fontSizeXl: '16px',
            borderRadius: '4px',
            colorBackground: darkMode ? '#181818' : undefined,

            // Commented out for now as it's proving difficult to get colors in this.
            // You can pass in colors from a specific app's theme object, but they are formatted as
            // "var(--text-success, #008060)", which Stripe rejects.

            // colorPrimary: 'var(--text-primary)', // can you pass in our token vars?
            // colorBackground: '--surface-01',
            // colorText: '--text-default',
            // colorDanger: '--text-danger',
            // colorSuccess: '--text-success',
            // colorWarning: '--text-warning',
            // colorTextSecondary: '--text-subdued',
            // colorTextPlaceholder: '--text-placeholder',

            fontWeightNormal: '400',
            fontWeightMedium: '500',
            fontWeightBold: '700',
          },
          rules: {
            '.StripeElement': {
              padding: '24px',
            },
            '.Label':
              callSite === 'consumer_profile'
                ? {
                    fontWeight: '500',
                  }
                : {},
          },
        },
      });
    }
  });
  if (!clientSecret) {
    return null;
  }
  return (
      <>
      <div data-testid='payment'>
      <PaymentElement options={{ wallets: { applePay: 'never', googlePay: 'never' }}} onReady={paymentElementOnReady} />
      </div>
      {showAddressFields &&
      <div data-testid='billing'>
      <AddressElement options={{ mode: 'billing'}} onReady={(element) =>  {
        element.clear();
      }}/>
      </div>
      }
      </>
  )
};
